import { render, staticRenderFns } from "./InfoAboutSubmit.vue?vue&type=template&id=f9900842&scoped=true&"
import script from "./InfoAboutSubmit.vue?vue&type=script&lang=js&"
export * from "./InfoAboutSubmit.vue?vue&type=script&lang=js&"
import style0 from "./InfoAboutSubmit.vue?vue&type=style&index=0&id=f9900842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9900842",
  null
  
)

export default component.exports